'use client';

import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface SignOutButtonProps {
  onSignOut: () => void;
}

export const SignOutButton = ({ onSignOut }: SignOutButtonProps) => {
  const { tabBarMenu: tabBarMenuIcons } = useTheme();
  const { t } = useTranslation();

  return (
    <button onClick={onSignOut}>
      <tabBarMenuIcons.signout.component />
      {t('button.signOut')}
    </button>
  );
};
